export const REFRESH_USER_BALANCES_START =
  'REFRESH_USER_BALANCES_START';
export const REFRESH_USER_BALANCES_SUCCESS =
  'REFRESH_USER_BALANCES_SUCCESS';
export const REFRESH_USER_BALANCES_FAILED =
  'REFRESH_USER_BALANCES_FAILED';
